module.exports = __webpack_public_path__ + "images/Elastic-05a611.png";